// original code from  ACEPayments/src/utils/cookieHelper.js                                                                                                                                      898/898               100%

export default class CookieHelper {
  static getCookie(name: any) {
    if ((global as any).document) {
      const value = `; ${(global as any).document.cookie}`;
      let parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop()?.split(';').shift();
    }
    return null;
  }

  static getClubCodeFromZipcodeCookie() {
    const zipcodeCookie = CookieHelper.getCookie('zipcode');
    let zipcodeResult = '';
    if (zipcodeCookie) {
      const zipcodeCookieArray = zipcodeCookie.split('|');
      zipcodeResult = zipcodeCookieArray[2] ? zipcodeCookieArray[2] : '';
    }
    return zipcodeResult.trim().padStart(3, '0');
  }

  static getZipcodeFromZipcodeCookie() {
    const zipcodeCookie = CookieHelper.getCookie('zipcode');

    if (zipcodeCookie) {
      const zipcodeCookieArray = zipcodeCookie.replace('"', '').split('|');
      let zipcodeResult: any = zipcodeCookieArray[0]
        ? zipcodeCookieArray[0]
        : null;
      return zipcodeResult;
    }

    return null;
  }
}
